import { decorate, observable, action } from 'mobx';
import { UNAUTHORIZED } from 'http-status';

import StorageService from '../../services/storage';

import { authenticate } from '../../apis/six-api/v2/auth';

import { routerStore } from '../RouterStore';

export default class AuthStore {
  isLoading = false;

  response = {
    accessToken: '',
    refreshToken: '',
    expiresIn: 0,
    tokenType: '',
    auth: {
      uuid: '',
      'link.uuid': '',
    },
  };

  toAuthenticate = async (uuid, linkUuid) => {
    try {
      StorageService.clearStorage();
      this.isLoading = true;

      const {
        data: { records },
      } = await authenticate(uuid, linkUuid);

      StorageService.setUuid(records[0].auth.uuid);
      StorageService.setLinkUuid(records[0].auth['link.uuid']);
      StorageService.setAccessToken(records[0].accessToken);
      StorageService.setRefreshToken(records[0].refreshToken);

      routerStore.push('/agendamentos');
    } catch (error) {
      if (error.response && error.response.status !== UNAUTHORIZED) {
        routerStore.push('/error');
      }
    } finally {
      this.isLoading = false;
    }
  };
}

decorate(AuthStore, {
  isLoading: observable,
  response: observable,
  toAuthenticate: action,
});

const authStore = new AuthStore();

export { authStore };
